import styled from 'styled-components';
import theme from 'styled-theming';

export const backgroundColor = theme('name', {
  light: '#fff',
  dark: 'rgba(30,36,43,1)',
});

interface ColType {
  size: number;
}

const number12 = 12;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;
export const FormRow = styled(Row)`
  align-items: flex-start;
  margin-bottom: 1rem;
`;
export const Col = styled.div<ColType>`
  flex: 0 0 ${(props) => (props.size * 100) / number12}%;
  max-width: ${(props) => (props.size * 100) / number12}%;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  background-color: ${backgroundColor};
  padding: 0 10px;
  position: relative;
`;
